// src/components/financials/BalanceSheetSimple.jsx
// SCREENER-FINANCIALS — new file. "Simple Mode" for the Balance Sheet: the
// accounting equation (Assets = Liabilities + Equity) shown as two bars of
// equal total length — one solid ("What They Own"), one split into two
// segments ("What They Owe" + "What's Left for Owners") — so the equality
// itself is visually obvious without knowing what "stockholders' equity"
// means as a term.

import React from 'react';

function fmtCompact(n) {
  if (n == null) return '—';
  const abs = Math.abs(Number(n));
  const sign = n < 0 ? '-' : '';
  if (abs >= 1e9) return sign + '$' + (abs / 1e9).toFixed(2) + 'B';
  if (abs >= 1e6) return sign + '$' + (abs / 1e6).toFixed(2) + 'M';
  if (abs >= 1e3) return sign + '$' + (abs / 1e3).toFixed(1) + 'K';
  return sign + '$' + abs.toFixed(0);
}

export default function BalanceSheetSimple({ statements }) {
  const s = statements;
  const assets = s.totalAssets;
  const liabilities = s.totalLiabilities;
  const equity = s.totalStockholdersEquity;

  if (assets == null) {
    return (
      <div style={{ padding: '1rem', textAlign: 'center', color: '#475569', fontSize: '0.78rem' }}>
        Total Assets not captured for this period.
      </div>
    );
  }

  const liabPct = assets > 0 && liabilities != null ? Math.max(0, Math.min(100, (liabilities / assets) * 100)) : 0;
  const equityPct = 100 - liabPct;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
        <span style={{ fontSize: '0.8rem', color: '#cbd5e1' }}>🏦 What They Own (Total Assets)</span>
        <span style={{ fontSize: '0.9rem', fontWeight: 800, color: '#f8fafc' }}>{fmtCompact(assets)}</span>
      </div>
      <div style={{ height: '14px', background: '#00d4ff', borderRadius: '6px', marginBottom: '1.1rem' }} />

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
        <span style={{ fontSize: '0.8rem', color: '#cbd5e1' }}>💳 What They Owe + 🏛️ What's Left for Owners</span>
      </div>
      <div style={{ height: '14px', borderRadius: '6px', overflow: 'hidden', display: 'flex', marginBottom: '0.5rem' }}>
        <div style={{ width: liabPct + '%', background: '#ffaa00' }} title="Liabilities" />
        <div style={{ width: equityPct + '%', background: '#00ff88' }} title="Equity" />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.72rem' }}>
        <span style={{ color: '#ffaa00' }}>■ Owes: {fmtCompact(liabilities)}</span>
        <span style={{ color: '#00ff88' }}>■ Owners' Share: {fmtCompact(equity)}</span>
      </div>

      <div style={{ marginTop: '1rem', paddingTop: '0.75rem', borderTop: '1px solid rgba(255,255,255,0.06)',
        display: 'flex', justifyContent: 'space-between' }}>
        <span style={{ fontSize: '0.78rem', color: '#64748b' }}>💵 Cash on Hand</span>
        <span style={{ fontSize: '0.85rem', fontWeight: 700, color: '#f8fafc' }}>{fmtCompact(s.cashAndEquivalents)}</span>
      </div>
    </div>
  );
}
